import { Settings } from "luxon";

Settings.defaultLocale = "de-DE";